<template>
	<div class="row">
		<div class="col-xl-8">
			<div class="card">
				<div class="card-body">
					<h5>
						<i class="fas fa-address-card" aria-hidden="true"></i> Edición datos personales
					</h5>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Rut">
								<b-form-input
									type="text"
									v-model="jsonAlumno.numeroDocumento"
									:class="{ disabled: true }"
									disabled="disabled"
									placeholder="Ingrese el rut del alumno"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Nombre Alumno">
								<b-form-input
									type="text"
									v-model="jsonAlumno.nombre"
									:class="{ 'is-invalid': camposVacio.nombre, disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									v-on:keyup="camposValidacion(jsonAlumno)"
									placeholder="Ingrese el nombre del alumno"
								 	:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"

								></b-form-input>
								<span v-if="error.nombre" style="color:red">{{
									error.nombre[0]
								}}</span>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="input-group-1" label="Apellido Alumno">
								<b-form-input
									type="text"
									v-model="jsonAlumno.apellido"
									:class="{ 'is-invalid': camposVacio.apellido, disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									v-on:keyup="camposValidacion(jsonAlumno)"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
								<span v-if="error.apellido" style="color:red">{{
									error.apellido[0]
								}}</span>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Correo">
								<b-form-input
									type="text"
									v-model="jsonAlumno.email"
									:class="{ 'is-invalid': camposVacio.email, disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									v-on:keyup="camposValidacion(jsonAlumno)"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
								<span v-if="error.email" style="color:red">{{
									error.email[0]
								}}</span>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="input-group-1" label="Fecha Nacimiento">
								<Datepicker
									v-model="date"
									:language="es"
									:bootstrap-styling="true"
									@selected="fechaSeleccionada($event)"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></Datepicker>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="País">
								<b-form-select
									:value="jsonAlumno.idPais"
									:options="optionsPais"
									@change="seleccionPais($event)"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-select>
							</b-form-group>
						</b-col>

						<b-col>
							<b-form-group id="input-group-1" label="Región">
								<b-form-select
									v-model="jsonAlumno.idRegion"
									:options="jsonRegionAlumno"
									:class="{ disabled: disabledRegion, disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="disabledRegion || (jsonCoordinadora.edicionAlumno) ? false : true" 
									@change="seleccionRegion($event)">
									  <b-form-select-option :value="null" disabled>-- Selecciona una opción {{jsonAlumno.idRegion}} --</b-form-select-option
									>
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Comuna">
								<b-form-select
									v-model="jsonAlumno.idComuna"
									:options="jsonComunaAlumno"
									:class="{ disabled: disabledComuna, disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="disabledComuna || (jsonCoordinadora.edicionAlumno) ? false : true"
									@change="seleccionComuna($event)">
									<b-form-select-option :value="null" disabled>-- Selecciona una opción {{jsonAlumno.idComuna}}--</b-form-select-option>
								</b-form-select>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="input-group-1" label="Dirección">
								<b-form-input
									type="text"
									v-model="jsonAlumno.direccion"
									placeholder="Ingrese la dirección del alumno"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Teléfono Móvil">
								<b-form-input
									type="text"
									v-model="jsonAlumno.telefonoMovil"
									placeholder="Ingrese el telefono movil del alumno"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="input-group-1" label="Teléfono">
								<b-form-input
									type="text"
									v-model="jsonAlumno.telefonoFijo"
									placeholder="Ingrese el telefono fijo del alumno"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Cargo">
								<b-form-input
									type="text"
									v-model="jsonAlumno.cargo"
									placeholder="Ingrese el cargo del alumno"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-input>
							</b-form-group>
						</b-col>

						<b-col>
							<b-form-group id="input-group-1" label="Area/Gerencia">
							<b-form-input
									type="text"
									v-model="jsonAlumno.areaGerencia"
									placeholder="Ingrese el Area"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
							></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="input-group-1" label="Empresa">
								<b-form-select
									:value="jsonAlumno.idEmpresa"
									:options="optionsEmpresa"
									@change="changeEmpresa($event)"
									:class="{disabled: (jsonCoordinadora.edicionAlumno) ? false : true }"
									:disabled="(jsonCoordinadora.edicionAlumno) ? false : true"
								></b-form-select>
								<span v-if="jsonAlumno.idEmpresa == showEmpresaError" style="color:red">No tienes acceso a la empresa actual del alumno, debes cambiarla o dejarla igual.</span>
								<br>
								<br>
								<span v-if="showFechaError == true" style="color:red">La fecha de nacimiento del usuario no se ha definido aún.</span>
							</b-form-group>
						</b-col>
					</b-row>
					<hr />
					<div align="right">
						<b-button block v-if="jsonCoordinadora.edicionAlumno" variant="primary" @click="updateAlumno()"
							><b-spinner v-if="arrayButton[0].btnEdicion" small> </b-spinner>
							{{ arrayButton[0].msgButtonEdicion }}
						</b-button>
							<b-button block v-else>
								{{ arrayButton[0].msgButtonEdicion }}
						</b-button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xl-4">
			<reinicioPassword></reinicioPassword>
			<!-- <accesoCampus></accesoCampus> -->
		</div>
		<!-- end col -->
		<toastComponent ref="toastComponent"></toastComponent>
	</div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapState } from "vuex";
import { es } from "vuejs-datepicker/dist/locale";

import toastComponent from "@/components/toastComponent";
import reinicioPassword from "@/components/alumno/infoPersonal/reinicioPassword";
import accesoCampus from "@/components/alumno/infoPersonal/accesoCampus";
export default {
	components: {
		Datepicker,
		toastComponent,
		reinicioPassword,
		accesoCampus
	},
	data() {
		return {
			value: "",
			arrayButton: [
				{ msgButtonEdicion: "Aceptar", btnEdicion: false },
				{ msgButtonPasword: "Reiniciar Contraseña", btnPassword: false },
				{ msgButtonAcceso: "Agregar Campus", btnCampus: false }
			],
			context: null,
			fechaNacimiento: "",

			optionsPais: [
				{ value: 1, text: "Chile" },
				{ value: 2, text: "Peru" },
				{ value: 3, text: "Paraguay" },
				{ value: 4, text: "Argentina" },
				{ value: 5, text: "Uruguay" }
			],
			optionsEmpresa:[
				{ value: null, text: "Por favor Selecciona una empresa disponible" }
			],
			optionsRegion: [],
			optionsComunas: [],
			disabledRegion: false,
			disabledComuna: false,
			es: es,
			error: {},
			camposVacio: {},
			passwordAlumno: "",
			showEmpresaError:null,
			showFechaError:false
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
		...mapState("alumno", ["jsonRegionAlumno"]),
		...mapState("alumno", ["jsonComunaAlumno"]),
		...mapState('alumno',['jsonCoordinadora']),
		date: {
			get() {
				if (this.jsonAlumno.fecha_nacimiento) {
					if(this.jsonAlumno.fecha_nacimiento == "0000-00-00"){						
						this.showFechaError = true;
						return new Date();
					}else{
						this.showFechaError = false;
						let d = new Date(this.jsonAlumno.fecha_nacimiento);
						d.setDate((d.getDate()+1));
						return d;
					}
				}else{
					this.showFechaError = true;
					return new Date();
				}
			},
			set(newDate) {
				this.showFechaError = true;
				return new Date();
			}
		}
	},
	mounted(){
       this.startFunction();
	},
	methods: {
		...mapActions("alumno", ["updateComunaJson"]),
		...mapActions("alumno", ["updateRegionJson"]),
		...mapActions("alumno", ["updateJsonAlumno"]),
		...mapActions("alumno", ["updateJsonCoordinadora"]),
		camposValidacion(param) {
			if (param.nombre) {
				this.camposVacio.nombre = false;
			}
			if (param.apellido) {
				this.camposVacio.apellido = false;
			}
			if (param.email) {
				this.camposVacio.email = false;
			}
		},
		async startFunction(){
			//recargar los privilegios de la coordinadora en caso de que se obtengan desde otra vista
			if(this.jsonAlumno.idPais == undefined){
				let newJsonAlumno = await this.getInfoAlumno();
				this.updateJsonAlumno(newJsonAlumno);
			}

		    //formatear empresas según el cliente
			if(this.$route.name == "busquedaAlumno" || this.$route.name == "infoAlumno"){
				if(this.optionsEmpresa.length == 1){
				   if(this.jsonAlumno.empresa.idCliente != undefined){
					   this.axios.get("api/getEmpresasIdCliente/" + this.jsonAlumno.empresa.idCliente).then((res)=>{
						   if(res.data.ok){
							   res.data.empresas.map((e)=>{
                                   this.optionsEmpresa.push({
										value: e.idEmpresa,
										text: e.tituloEmpresa
									});
							   });
						   }
					   }).catch((e)=>console.log(e));
				   }
				}
			}else{
				if(this.optionsEmpresa.length == 1){
					JSON.parse(window.atob(localStorage.getItem('usuarioDB'))).empresas.map(emp =>{
						this.optionsEmpresa.push({
							value: emp.idEmpresa,
							text: emp.tituloEmpresa
						});
					});
					if(this.optionsEmpresa.find(element => element.value == this.jsonAlumno.empresa.idEmpresa) == undefined){
						this.showEmpresaError =  this.jsonAlumno.empresa.idEmpresa;
						this.optionsEmpresa.push({
							value: this.jsonAlumno.empresa.idEmpresa,
							text: this.jsonAlumno.empresa.tituloEmpresa
						});
					}
				}
			}

			this.getRegion(this.jsonAlumno.idPais);
			this.getComunas(this.jsonAlumno.idRegion);
            const { data } = await this.axios.get("api/getLoginLogeado");
			const { usuarioDB: user } = data;
			const { data: dataCoordinadora } = await this.axios.get(`api/getCoordinadoraCampus`);
			this.updateJsonCoordinadora({ ...user,privilegios:dataCoordinadora.getPrivilegios });
		},
		async updateAlumno() {
			this.arrayButton[0].btnEdicion = true;
			this.arrayButton[0].msgButtonEdicion = "Cargando porfavor espere...";

			var fechaNacimientoAlumno = this.fechaNacimiento
				? this.fechaNacimiento
				: this.jsonAlumno.idAlumno;

			const form = {
				idAlumno: this.jsonAlumno.idAlumno,
				nombre: this.jsonAlumno.nombre,
				apellido: this.jsonAlumno.apellido,
				email: this.jsonAlumno.email,
				fechaNacimiento: this.fechaNacimiento,
				pais: this.jsonAlumno.idPais,
				region: this.jsonAlumno.idRegion,
				comuna: this.jsonAlumno.idComuna,
				direccion: this.jsonAlumno.direccion,
				cargo: this.jsonAlumno.cargo,
				telefonoMovil: this.jsonAlumno.telefonoMovil,
				telefonoFijo: this.jsonAlumno.telefonoFijo,
				areaGerencia:this.jsonAlumno.areaGerencia,
				idEmpresa:this.jsonAlumno.idEmpresa
			};
			const { data } = await this.axios.put("api/updateAlumno", form);
			const { estado, errores, msg } = data;
			const arrayToast = {
				msg: "",
				title: "",
				variant: ""
			};

			switch (estado) {
				case "camposVacios":
					this.error = errores;
					this.camposVacio = this.error;
					break;
				case "cambiosHechos":
					arrayToast.msg = msg;
					arrayToast.title = "Exito";
					arrayToast.variant = "success";
					this.$refs.toastComponent.makeToast(arrayToast);
					break;
				case "sinCambios":
					arrayToast.msg = msg;
					arrayToast.title = "Atencion";
					arrayToast.variant = "warning";
					this.$refs.toastComponent.makeToast(arrayToast);
					break;
			}

			this.arrayButton[0].btnEdicion = false;
			this.arrayButton[0].msgButtonEdicion = "Editar Infomacion Personal";
		},
		fechaSeleccionada(event) {
			this.fechaNacimiento = this.GetDateFormat(event);
		},
		async getRegion(idPais) {
			const { data } = await this.axios.get("api/getRegionPais/" + idPais);
			const { getRegion: region } = data;

			const regiones = region.map(reg => ({
				value: reg.idRegion,
				text: reg.nombreRegion
			}));

			// //carga vuex
			this.updateRegionJson(regiones);
		},
		async getComunas(idRegion) {
			const { data } = await this.axios.get("api/getComunasRegion/" + idRegion);
			const { getComuna: comuna } = data;

			const comunas = comuna.map(com => ({
				value: com.idComuna,
				text: com.nombreComuna
			}));

			// //carga vuex
			this.updateComunaJson(comunas);
			this.disabledComuna = false;
		},
		GetDateFormat(date) {
			var month = (date.getMonth() + 1).toString();
			month = month.length > 1 ? month : "0" + month;
			var day = date.getDate().toString();
			day = day.length > 1 ? day : "0" + day;

			return date.getFullYear() + "-" + month + "-" + day;
		},
		seleccionPais(event) {
			this.jsonAlumno.idPais = event;
			this.optionsRegion = [];
			this.optionsComunas = [];
			this.getRegion(event);
			this.selectedRegion = null;

			if (event != 1) {
				this.disabledRegion = true;
				this.disabledComuna = true;
			} else {
				this.disabledRegion = false;
				this.disabledComuna = false;
			}
		},
		seleccionRegion(event) {
			this.jsonAlumno.idRegion = event;
			this.disabledComuna = true;
			this.optionsComunas = [];
			this.getComunas(event);
		},
		seleccionComuna(event) {
			this.jsonAlumno.idComuna = event;
		},
		changeEmpresa(event) {
			this.jsonAlumno.idEmpresa = event;
		},
		async getInfoAlumno() {
			let result = await this.axios.get("api/getIdAlumno/" + this.$route.params.idAlumno);
			return result.data.alumno;
		},
	}
};
</script>
